import { getRootDomain } from 'core'

export default defineNuxtRouteMiddleware((to) => {
  if (!import.meta.client || import.meta.env.DEV)
    return

  const { origin } = location
  const rootDomain = getRootDomain(origin)

  // Ignore on vocal domain
  if (!isCustomDomain(origin) || origin === rootDomain)
    return

  // Ignore /listen - /meeting - /join pages
  if (/^\/(listen|meeting|join)(\/|$)/i.test(to.path))
    return

  return navigateTo(rootDomain, {
    external: true
  })
})
